<div class="custom-icon" [ngStyle]="styles">
    <img [src]="path + icon + iconExt " [alt]="icon">
</div>